import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/shared/services/api.service';
import { Observable } from 'rxjs';
import { CommonBookingService } from 'src/app/bookings/shared/common-booking.service';

@Injectable({
  providedIn: 'root'
})
export class InvoiceViewService {

  constructor(public apiService: ApiService, private commonBookingService: CommonBookingService,
            ) { }


  public fetchInvoiceDetails(searchQuery: any, request: any): Observable<any[]> {
    return this.apiService.httpRequest({
      url: 'fetchInvoices',
      type: 'POST',
      queryParams: searchQuery,
      body: request
    });
  }

  public generateInvoice(searchQuery: any): Observable<any[]> {
    return this.apiService.httpRequestBlob({
      url: 'generateInvoice',
      type: 'GET',
      queryParams: searchQuery
    });
  }

  public sendInvoice(request: any): Observable<any[]> {
    return this.apiService.httpRequest({
      url: 'sendInvoice',
      type: 'POST',
      body: request
    });
  }

  public downloadInvoice(searchQuery: any): Observable<any[]> {
    return this.apiService.httpRequestAsText({
      url: 'downloadInvoice',
      type: 'GET',
      queryParams: searchQuery
    });
  }

  public updateInvoiceStatus(request: any): Observable<any[]> {
    return this.apiService.httpRequest({
      url: 'updateInvoiceStatus',
      type: 'POST',
      body: request
    });
  }

  public updateRiderInvoice(request: any): Observable<any[]> {
    return this.apiService.httpRequest({
      url: 'updateRiderInvoice',
      type: 'PUT',
      body: request
    });
  }

  public fetchInvoiceImageBlob(searchQuery: any): Observable<any[]> {
    return this.apiService.httpRequestBlob({
      url: 'fetchInvoiceImageBlob',
      type: 'GET',
      queryParams: searchQuery
    });
  }

  public uploadInvoiceFiles(queryParams: any, request: any): Observable<any[]> {
    const postData = new FormData();
    postData.append('uploadingFiles', request.uploadingFiles);
    return this.apiService.httpRequestBlob({
      url: 'uploadInvoiceFiles',
      type: 'POST',
      queryParams,
      body: postData,
      fileUpload: true
    });
  }

  public downloadAllDocAsZip(queryParams) {
    return this.apiService.httpRequestDownloadZipFile({
      url: 'downLoadZip',
      type: 'GET',
      queryParams
    });
  }

  public getAllDocumentList(searchQuery) {
    return this.apiService.httpRequest({
      url: 'getAllInvoiceDocument',
      type: 'GET',
      queryParams: searchQuery
    });
  }

  public viewUploadedDocument(queryParams) {
    return this.apiService.httpRequestBlob({
      url: 'viewUploadedDocument',
      type: 'GET',
      queryParams
    });
  }

  public uploadAllInvoiceDocuments(body) {
    const postData = new FormData();
    body.uploadingFiles.forEach((file) => {
      postData.append('uploadingFiles', file, file.name);
    });
    postData.append('invoiceUpdateInfo', new Blob([JSON.stringify(body.invoiceUpdateInfo)], { type: "application/json"}));
    return this.apiService.httpRequestFileAndModel({
      url: 'updateInvoice',
      type: 'POST',
      body : postData,
    });
  }

  fetchInvoiceAdjustment(queryParams: any) {
    return this.apiService.httpRequest({
      url: 'fetchInvoiceAdjustment',
      type: 'GET',
      queryParams
    });
  }

  fetchInvoiceTripInfo(queryParams: any) {
    return this.apiService.httpRequest({
      url: 'fetchInvoiceTripInfo',
      type: 'POST',
      body: queryParams
    });
  }

  fetchInvoiceBookingDetail(queryParams) {
    return this.apiService.httpRequest({
      url: 'getBillingInfoByBookingid',
      type: 'GET',
      queryParams
    });
  }


}
